module.exports = __webpack_public_path__ + "img/my_sessions_no_data.059cb0ac.svg";